import FullScreenIcon from "../images/fullscreen.svg?react";

/**Default: 24px by 24px */
export default function CoreFullScreenIcon({
	height = 24,
	width = 24,
	color = "#42296E",
}: {
	width?: string | number;
	height?: string | number;
	/**@default "#42296E" */
	color?: string;
}) {
	return <FullScreenIcon width={width} height={height} color={color} />;
}
